export const TEST_USERS = [
  {
    id: 'user_001',
    login: 'demo',
    password: 'demo123',
    name: 'Иван Соколов',
    role: 'chat-operator' as const,
    email: 'i.sokolov@portal.ru',
  },
];

export const MANAGER_INFO = {
  name: 'Мария',
  role: 'Менеджер по первичному набору',
  telegram: '@aleksandra_portal',
  email: 'a.petrova@portal.ru',
  avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20HR%20manager%20portrait%2C%20business%20formal%20attire%2C%20warm%20smile%2C%20clean%20white%20background%2C%20corporate%20headshot%20photography%2C%20soft%20lighting%2C%2035mm%20lens&width=200&height=200&seq=mgr001&orientation=squarish',
};

export const PROJECTS_LIST = [
  {
    id: 'proj_1',
    icon: 'ri-shopping-cart-line',
    color: '#10b981',
    title: 'E-commerce',
    description: 'Поддержка клиентов онлайн-магазинов (вопросы по заказам, доставке, возвратам, ассортименту).',
  },
  {
    id: 'proj_2',
    icon: 'ri-code-s-slash-line',
    color: '#f59e0b',
    title: 'IT и SaaS',
    description: 'Помощь пользователям программных продуктов или облачных сервисов (технические вопросы, настройка, функционал).',
  },
  {
    id: 'proj_3',
    icon: 'ri-bank-line',
    color: '#8b5cf6',
    title: 'Финансовый сектор',
    description: 'Консультации по банковским продуктам, кредитам, инвестициям (после глубокого обучения и с соблюдением всех регуляций).',
  },
  {
    id: 'proj_4',
    icon: 'ri-customer-service-line',
    color: '#ef4444',
    title: 'Сфера услуг',
    description: 'Поддержка клиентов сервисов доставки, бронирования, образовательных платформ и т.д.',
  },
  {
    id: 'proj_5',
    icon: 'ri-wifi-line',
    color: '#06b6d4',
    title: 'Телекоммуникации',
    description: 'Консультации по тарифам, услугам связи, настройке оборудования.',
  },
];
